import { useQuery, useMutation } from "@tanstack/react-query"
import {
  getTransactions,
  getTransactionStats,
  exportTransactions,
} from "@/services/transactions"

export const TRANSACTIONS_QUERY_KEYS = {
  LIST: ["transactions", "list"] as const,
  STATS: ["transactions", "stats"] as const,
}

export function useTransactionStats(enabled = true) {
  return useQuery({
    queryKey: TRANSACTIONS_QUERY_KEYS.STATS,
    queryFn: () => getTransactionStats(),
    enabled,
    staleTime: 30000,
  })
}

export function useTransactionsPaginated(
  params?: { page?: number; per?: number },
  enabled = true
) {
  const { page = 1, per = 10 } = params ?? {}
  return useQuery({
    queryKey: [...TRANSACTIONS_QUERY_KEYS.LIST, "paginated", { page, per }],
    queryFn: async () => {
      const response = await getTransactions({ page, per })
      return {
        transactions: response.data,
        meta: response.meta,
      }
    },
    enabled,
    staleTime: 30000,
  })
}

export function useExportTransactions() {
  return useMutation({
    mutationFn: async () => {
      const blob = await exportTransactions()
      const date = new Date().toISOString().slice(0, 10)
      const filename = `transactions_${date}.csv`
      const url = URL.createObjectURL(blob)
      const a = document.createElement("a")
      a.href = url
      a.download = filename
      a.click()
      URL.revokeObjectURL(url)
    },
  })
}
